export const logOutStarted = (state) => {
    return {
        ...state,
        logOutApi: {
            isProcessing: true,
            error: false
        }
    }

}
export const logOutSuccess = (state) => {
    return {
        ...state,
        logOutApi: {
            isProcessing: false,
            error: false
        }
    }

}
export const logOutFailed = (state) => {
    return {
        ...state,
        logOutApi: {
            isProcessing: false,
            error: false
        }
    }
}